import mixpanel from './mixpanel';
import sentry from './sentry';
import mouseflowUtil from '../../utils/mouseflow';
import { getAuthCookies } from './authCookies';

export interface UserData {
  id?: string;
  email?: string;
  name?: string;
  type?: string;
  business_id?: string;
}

export const identifyUserData = (userData: UserData): void => {
  if (!userData.id) return;

  mixpanel.identify(userData.id);

  mixpanel.set_once({
    'First Login Date': new Date(),
    'Default user Id': userData.id,
  });

  const profileProps: Record<string, string> = {};
  if (userData.email) profileProps.$email = userData.email;
  if (userData.name) profileProps.$name = userData.name;
  if (userData.type) profileProps.user_role = userData.type;
  if (Object.keys(profileProps).length > 0) {
    mixpanel.set(profileProps);
  }

  if (userData.type) {
    mixpanel.register({ user_role: userData.type });
  }

  sentry.identify(
    userData.id,
    userData.type,
    userData.email,
    userData.name,
    userData.business_id
  );

  mouseflowUtil.SET_USER_DATA({
    id: userData.id,
    name: userData.name,
    business_id: userData.business_id,
    type: userData.type,
  });
};

export const identifyFromCookies = (): void => {
  const authCookies = getAuthCookies();
  if (authCookies) {
    identifyUserData({ id: authCookies.id, type: authCookies.type });
  }
};

export const resetAnalytics = (): void => {
  mixpanel.reset();
  sentry.reset();
};
